export default __webpack_public_path__ + "static/media/3.c1d54869.jpg";